(function () {
  const GRAPHQL_URL = "/api/graphql";
  const STOREFRONT_TOKEN = "9f8ac716aec31cfbe53256192f2152f1";

  const GRID_WRAPPER_SELECTOR = ".boost-sd__product-list, .boost-sd__product-grid, .boost-sd__product-grid-group, .boost-sd__product-listing";
  const CARD_SELECTOR = ".boost-sd__product-item[data-product-id]";
  const TITLE_SELECTOR = ".boost-sd__product-title";
  const INSERT_TARGET_SELECTOR = ".ukr__review__productcode__wrapper";

  const groupTagCache = new Map();
  const groupProductsCache = new Map();
  const inFlightGroupTag = new Map();
  const inFlightGroupProducts = new Map();
  const prefetchedLinks = new Set();

  let io = null;
  let mo = null;
  let currentGridRoot = null;

  function getColourTools() {
    return window.UKRProductColours || {};
  }

  function extractColourFromTitle(title) {
    const tools = getColourTools();

    if (typeof tools.extractColourFromTitle === "function") {
      return tools.extractColourFromTitle(title);
    }

    return null;
  }

  function getColourClass(colour) {
    const tools = getColourTools();

    if (typeof tools.getColourClass === "function") {
      return tools.getColourClass(colour);
    }

    return "";
  }

  function getColourOrder() {
    return getColourTools().order || [];
  }

  const PRODUCT_TITLE_KEYWORDS = [
    "Radiator T-Piece",
    "Valve & Blanking Plug",
    "Valves",
    "Column Radiator Feet",
    "Radiator Valve Tail Extension",
    "Thermostatic Radiator Valve & Installation Kit",
    "Radiator Valve & Lockshield",
    "Towel Rail Valve",
    "Towel Rail Kit",
    "Valve",
    "Radiator Wall Stay",
    "Radiator Inhibitor",
    "Element",
    "Towel Rail",
    "Pipe Covers",
    "Radiator",
  ];

  function parseCollectionProductTitle(title) {
    if (!title) return null;

    title = title.replace(/\n/g, " ").replace(/\s+/g, " ").trim();

    let brand = "";
    let remainder = title;

    const firstSplitIndex = title.indexOf(" - ");

    if (firstSplitIndex !== -1) {
      const potentialBrand = title.substring(0, firstSplitIndex).trim();

      const brandContainsKeyword = PRODUCT_TITLE_KEYWORDS.some(function (keyword) {
        return potentialBrand.includes(keyword);
      });

      if (!brandContainsKeyword) {
        brand = potentialBrand;
        remainder = title.substring(firstSplitIndex + 3).trim();
      }
    }

    let productName = remainder;
    let afterProduct = "";
    let foundKeyword = null;

    for (const keyword of PRODUCT_TITLE_KEYWORDS) {
      if (remainder.includes(keyword)) {
        foundKeyword = keyword;
        break;
      }
    }

    if (foundKeyword) {
      const parts = remainder.split(foundKeyword);
      productName = parts[0] + foundKeyword;
      afterProduct = parts.slice(1).join(foundKeyword).trim();
    } else {
      const lastDashIndex = remainder.lastIndexOf(" - ");

      if (lastDashIndex !== -1) {
        productName = remainder.substring(0, lastDashIndex).trim();
        afterProduct = remainder.substring(lastDashIndex + 3).trim();
      }
    }

    if (afterProduct.startsWith("-")) {
      afterProduct = afterProduct.substring(1).trim();
    }

    let size = "";
    let type = "";

    if (afterProduct) {
      const afterParts = afterProduct.split(" ");

      if (afterParts.length >= 3 && afterParts[1] === "x") {
        size = afterParts.slice(0, 3).join(" ");
        type = afterParts.slice(3).join(" ");
      } else {
        size = afterProduct;
      }
    }

    return {
      brand: brand.trim(),
      productName: productName.trim(),
      size: size.trim(),
      type: type.trim(),
    };
  }

  function appendCollectionTitlePart(titleEl, className, text) {
    if (!text) return;

    const span = document.createElement("span");
    span.className = className;
    span.textContent = text;
    titleEl.appendChild(span);
  }

  function renderCollectionProductTitle(titleEl, title) {
    if (!titleEl) return;

    const data = parseCollectionProductTitle(title);

    titleEl.dataset.productTitle = title || "";
    titleEl.replaceChildren();

    if (!data) {
      titleEl.textContent = title || "";
      return;
    }

    const sizeAndType = `${data.size || ""} ${data.type || ""}`.trim();

    appendCollectionTitlePart(
      titleEl,
      "ukr-collection-product-title__brand",
      data.brand
    );

    appendCollectionTitlePart(
      titleEl,
      "ukr-collection-product-title__name",
      data.productName
    );

    appendCollectionTitlePart(
      titleEl,
      "ukr-collection-product-title__details",
      sizeAndType ? `(${sizeAndType})` : ""
    );
  }

  function waitForElement(selector, trigger, delayInterval = 50, delayTimeout = 15000) {
    const interval = setInterval(function () {
      if (document.querySelector(selector)) {
        clearInterval(interval);
        trigger();
      }
    }, delayInterval);

    setTimeout(function () {
      clearInterval(interval);
    }, delayTimeout);
  }

  function debounce(func, timeout = 300) {
    let timer;

    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(this, args);
      }, timeout);
    };
  }

  function live(selector, event, callback, context) {
    if (typeof callback !== "function") return;

    context = context || document;

    context.addEventListener(event, function (e) {
      const el = e.target.closest(selector);

      if (el && context.contains(el)) {
        callback.call(el, e);
      }
    });
  }

  function getProductTypeFromTitle(title) {
    if (/pipe covers?/i.test(title || "")) return "Pipe Covers";
    if (/column feet/i.test(title || "")) return "Column Feet";
    if (/\bvalves?\b/i.test(title || "")) return "Valves";
    if (/\belements?\b/i.test(title || "")) return "Elements";
    if (/\baccessories\b/i.test(title || "")) return "Accessories";

    return "Radiators";
  }

  function extractSizeFromTitle(title, productType) {
    if (productType === "Accessories" || productType === "Pipe Covers") {
      const accessorySizeMatch = (title || "").match(/(\d+)mm/i);
      if (accessorySizeMatch) return accessorySizeMatch[1];
    }

    const sizeMatch = (title || "").match(/H(\d+)mm x W(\d+)mm/i);
    if (sizeMatch) return `${sizeMatch[1]} x ${sizeMatch[2]}`;

    return null;
  }

  function getTitleMeta(title) {
    title = title || "";

    const productType = getProductTypeFromTitle(title);
    const color = extractColourFromTitle(title);
    const size = extractSizeFromTitle(title, productType);
    const panel = title.match(/(Single|Double) Panel/i)?.[1] || null;

    let shape = null;
    const shapeMatch = title.match(/\b(Straight|Curved)\b/i);

    if (shapeMatch) {
      shape = shapeMatch[1].charAt(0).toUpperCase() + shapeMatch[1].slice(1).toLowerCase();
    }

    let style = null;

    if (productType === "Valves") {
      const styleMatch = title.match(/(corner|angled|straight)/i);

      if (styleMatch) {
        style = styleMatch[1].charAt(0).toUpperCase() + styleMatch[1].slice(1).toLowerCase();
      }
    }

    let wattage = null;

    if (productType === "Elements") {
      const wattageMatch = title.match(/(\d+)w/i);
      if (wattageMatch) wattage = wattageMatch[1] + "W";
    }

    let column = null;
    const columnMatch = title.match(/(\d+ Column)/i);
    if (columnMatch) column = columnMatch[1];

    let controlType = null;

    if (title.includes("Thermostatic WIFI")) {
      controlType = "Thermostatic WIFI";
    } else if (title.includes("Thermostatic")) {
      controlType = "Thermostatic";
    } else if (title.includes("Standard")) {
      controlType = "Standard";
    }

    let width = null;

    if (productType === "Valves") {
      const widthMatch = title.match(/(\d+)mm/i);
      if (widthMatch) width = widthMatch[1] + "mm";
    }

    const feetType = title.includes("Feet Included") ? "With Feet" : "Without Feet";

    return {
      title,
      productType,
      color,
      size,
      panel,
      shape,
      style,
      wattage,
      column,
      controlType,
      width,
      feetType,
      isVertical: /\bvertical\b/i.test(title),
      isHorizontal: /\bhorizontal\b/i.test(title),
    };
  }

  function isSameProductConfig(productTitle, currentTitle, optionType, value, config = {}) {
    const { ignoreShape = false } = config;

    const current = getTitleMeta(currentTitle);
    const product = getTitleMeta(productTitle);

    const colorMatches = optionType === "colour" ? product.color === value : product.color === current.color;
    const sizeMatches = optionType === "size" ? product.size === value : product.size === current.size;

    const panelMatches = current.panel || product.panel
      ? optionType === "panel"
        ? product.panel === value
        : product.panel === current.panel
      : true;

    const shapeMatches = ignoreShape
      ? true
      : current.shape || product.shape
        ? optionType === "shape"
          ? product.shape === value
          : product.shape === current.shape
        : true;

    const styleMatches = current.productType === "Valves"
      ? optionType === "style"
        ? product.style === value
        : product.style === current.style
      : true;

    const wattageMatches = current.productType === "Elements"
      ? optionType === "wattage"
        ? product.wattage === value
        : product.wattage === current.wattage
      : true;

    const columnMatches = optionType === "column" ? product.column === value : product.column === current.column;
    const controlTypeMatches = optionType === "controlType" ? product.controlType === value : product.controlType === current.controlType;

    const widthMatches = current.productType === "Valves"
      ? optionType === "width"
        ? product.width === value
        : product.width === current.width
      : true;

    const feetTypeMatches = optionType === "feetType" ? product.feetType === value : product.feetType === current.feetType;

    const verticalMatches = product.isVertical === current.isVertical;
    const horizontalMatches = product.isHorizontal === current.isHorizontal;
    const productTypeMatches = product.productType === current.productType;

    return (
      productTypeMatches &&
      colorMatches &&
      sizeMatches &&
      panelMatches &&
      shapeMatches &&
      styleMatches &&
      wattageMatches &&
      columnMatches &&
      controlTypeMatches &&
      widthMatches &&
      feetTypeMatches &&
      verticalMatches &&
      horizontalMatches
    );
  }

  function findMatchingProductForColour(groupProducts, currentTitle, colour) {
    const currentMeta = getTitleMeta(currentTitle);

    const exactMatch = groupProducts.find(function (product) {
      return isSameProductConfig(product.title, currentTitle, "colour", colour, {
        ignoreShape: false,
      });
    });

    if (exactMatch) return exactMatch;

    const relaxedMatch = groupProducts.find(function (product) {
      return isSameProductConfig(product.title, currentTitle, "colour", colour, {
        ignoreShape: true,
      });
    });

    if (relaxedMatch) return relaxedMatch;

    return groupProducts.find(function (product) {
      const meta = getTitleMeta(product.title);

      return (
        meta.color === colour &&
        meta.size === currentMeta.size &&
        meta.productType === currentMeta.productType
      );
    }) || null;
  }

  function buildProductUrl(product) {
    return product.variantId
      ? `/products/${product.handle}?variant=${product.variantId}`
      : `/products/${product.handle}`;
  }

  function appendWidth(url, width) {
    if (!url) return "";
    return url.includes("?") ? `${url}&width=${width}` : `${url}?width=${width}`;
  }

  function buildSrcSet(url) {
    if (!url) return "";

    const widths = [320, 480, 768, 1024, 1440, 1920];

    return widths.map(function (width) {
      return `${appendWidth(url, width)} ${width}w`;
    }).join(", ");
  }

  async function graphqlRequest(query) {
    const response = await fetch(GRAPHQL_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query }),
    });

    const data = await response.json();

    if (data.errors) {
      throw new Error(data.errors[0]?.message || "GraphQL error");
    }

    return data;
  }

  async function getGroupTag(productId) {
    if (groupTagCache.has(productId)) return groupTagCache.get(productId);
    if (inFlightGroupTag.has(productId)) return inFlightGroupTag.get(productId);

    const promise = (async function () {
      const query = `
        {
          product(id: "gid://shopify/Product/${productId}") {
            tags
          }
        }
      `;

      const data = await graphqlRequest(query);
      const tags = data?.data?.product?.tags || [];
      const groupTag = tags.find(function (tag) {
        return tag.startsWith("group_");
      }) || null;

      groupTagCache.set(productId, groupTag);
      inFlightGroupTag.delete(productId);

      return groupTag;
    })().catch(function (error) {
      inFlightGroupTag.delete(productId);
      throw error;
    });

    inFlightGroupTag.set(productId, promise);
    return promise;
  }

  async function getProductsByGroup(groupTag) {
    if (!groupTag) return [];
    if (groupProductsCache.has(groupTag)) return groupProductsCache.get(groupTag);
    if (inFlightGroupProducts.has(groupTag)) return inFlightGroupProducts.get(groupTag);

    const promise = (async function () {
      const cleanGroupTag = groupTag.trim().replace(/'/g, "\\'").replace(/"/g, '\\"');

      async function runQuery(tagQuery) {
        let allEdges = [];
        let hasNextPage = true;
        let cursor = null;

        while (hasNextPage) {
          const afterCursor = cursor
            ? `, after: "${cursor}"`
            : "";

          const query = `
            {
              products(first: 250${afterCursor}, query: "${tagQuery}") {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    id
                    title
                    handle
                    tags
                    featuredImage {
                      url
                      altText
                    }
                    variants(first: 10) {
                      edges {
                        node {
                          id
                          availableForSale
                          price {
                            amount
                          }
                          compareAtPrice {
                            amount
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `;

          const data = await graphqlRequest(query);
          const connection = data?.data?.products;

          if (!connection) break;

          allEdges = allEdges.concat(connection.edges || []);
          hasNextPage = connection.pageInfo?.hasNextPage || false;
          cursor = connection.pageInfo?.endCursor || null;
        }

        return allEdges;
      }

      let edges = await runQuery(`tag:'${cleanGroupTag}'`);

      if (!edges.length) {
        edges = await runQuery(`tag:${cleanGroupTag}`);
      }

      const products = edges
        .map(function (edge) {
          return edge.node;
        })
        .filter(function (product) {
          return Array.isArray(product.tags) && product.tags.includes(groupTag);
        })
        .map(function (product) {
          const variants = (product.variants?.edges || []).map(function (edge) {
            return edge.node;
          });

          const firstVariant = variants[0] || null;

          return {
            id: product.id,
            title: product.title,
            handle: product.handle,
            tags: product.tags || [],
            featuredImage: product.featuredImage || null,
            variantId: firstVariant ? firstVariant.id.split("/").pop() : "",
            isAvailable: variants.some(function (variant) {
              return variant.availableForSale;
            }),
            price: firstVariant?.price?.amount || null,
            compareAtPrice: firstVariant?.compareAtPrice?.amount || null,
          };
        });

      groupProductsCache.set(groupTag, products);
      inFlightGroupProducts.delete(groupTag);

      return products;
    })().catch(function (error) {
      inFlightGroupProducts.delete(groupTag);
      throw error;
    });

    inFlightGroupProducts.set(groupTag, promise);
    return promise;
  }

  function prefetchUrl(url) {
    if (!url || prefetchedLinks.has(url)) return;

    const link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "document";
    link.href = url;

    document.head.appendChild(link);
    prefetchedLinks.add(url);
  }

  function getPrimaryTitle(card) {
    if (!card) return "";

    const currentTitle =
      card.dataset.creCurrentTitle ||
      card.dataset.productTitle;

    if (currentTitle) return currentTitle.trim();

    const titleEl = card.querySelector(TITLE_SELECTOR);

    return (
      titleEl?.dataset.productTitle ||
      titleEl?.textContent ||
      ""
    ).trim();
  }

  function getCurrentHandle(card) {
    return (
      card.dataset.creCurrentHandle ||
      (card.querySelector(".boost-sd__product-link-image")?.getAttribute("href") || "")
        .replace(/^\/products\//, "")
        .split("?")[0]
        .trim()
    );
  }

  function getCardSignature(card) {
    const productId = card.dataset.productId || "";
    const title = getPrimaryTitle(card) || "";
    const href = card.querySelector(".boost-sd__product-link-image")?.getAttribute("href") || "";

    return `${productId}|||${title}|||${href}`;
  }

  function removeSwatchPlaceholder(card) {
    const placeholder = card.querySelector(".cre-t-7-collection-colour-swatches-placeholder");

    if (placeholder) {
      placeholder.remove();
    }
  }

  function ensureSwatchPlaceholder(card) {
    const target = card.querySelector(INSERT_TARGET_SELECTOR) || card.querySelector(".boost-sd__product-info");
    if (!target) return;

    const hasRealSwatches = target.querySelector(".cre-t-7-collection-colour-swatches");
    if (hasRealSwatches) return;

    let placeholder = target.querySelector(".cre-t-7-collection-colour-swatches-placeholder");

    if (!placeholder) {
      placeholder = document.createElement("div");
      placeholder.className = "cre-t-7-collection-colour-swatches-placeholder";
      placeholder.setAttribute("aria-hidden", "true");
      target.prepend(placeholder);
    }
  }

  function resetCard(card) {
    const block = card.querySelector(".cre-t-7-collection-colour-swatches");

    if (block) {
      block.remove();
    }

    removeSwatchPlaceholder(card);

    delete card.dataset.creSwatchesReady;
    delete card.dataset.creSwatchesLoading;
    delete card.dataset.creCurrentHandle;
    delete card.dataset.creCurrentTitle;
    delete card.dataset.creSignature;
  }

  function updateSelectedSwatch(card, selectedHandle, selectedColour) {
    const swatches = Array.from(card.querySelectorAll(".cre-t-7-collection-colour-swatches__swatch"));

    swatches.forEach(function (swatch) {
      swatch.classList.remove("is-selected");
    });

    let selectedSwatch = null;

    if (selectedHandle) {
      selectedSwatch = swatches.find(function (swatch) {
        return swatch.dataset.handle === selectedHandle;
      }) || null;
    }

    if (!selectedSwatch && selectedColour) {
      selectedSwatch = swatches.find(function (swatch) {
        return swatch.dataset.colour === selectedColour && !swatch.classList.contains("is-unavailable");
      }) || null;
    }

    if (selectedSwatch) {
      selectedSwatch.classList.add("is-selected");
    }

    const labelCurrent = card.querySelector(".cre-t-7-collection-colour-swatches__label-current");
    if (labelCurrent) {
      labelCurrent.textContent = selectedColour || "";
    }
  }

  function updateCardLinks(card, url) {
    card.querySelectorAll(".boost-sd__product-link").forEach(function (link) {
      link.setAttribute("href", url);
    });
  }

  function updateCardTitles(card, title) {
    if (!card) return;

    card.dataset.productTitle = title || "";

    card.querySelectorAll(TITLE_SELECTOR).forEach(function (titleEl) {
      renderCollectionProductTitle(titleEl, title);
    });
  }

  function updateCardImage(card, data) {
    const imageLink = card.querySelector(".boost-sd__product-link-image");
    const image = card.querySelector(".boost-sd__product-image-img--main");

    if (imageLink && data.url) {
      imageLink.setAttribute("href", data.url);
    }

    if (!image || !data.image) return;

    image.setAttribute("src", appendWidth(data.image, 1920));
    image.setAttribute("srcset", buildSrcSet(data.image));
    image.setAttribute("alt", data.imageAlt || data.title || "");
  }

  function updateCardDiscountBanner(card, price, compareAtPrice) {
    if (!card) return;

    const cardWrapper = card.parentElement;
    if (!cardWrapper) return;

    const currentPrice = Number.parseFloat(price);
    const originalPrice = Number.parseFloat(compareAtPrice);

    const hasDiscount =
      Number.isFinite(currentPrice) &&
      Number.isFinite(originalPrice) &&
      originalPrice > 0 &&
      originalPrice > currentPrice;

    /*
    * Try to find an existing banner.
    * It is a sibling of the Boost product card, not inside it.
    */
    let saleTag =
      card.previousElementSibling?.matches(".hc-sale-tag")
        ? card.previousElementSibling
        : cardWrapper.querySelector(":scope > .hc-sale-tag");

    /*
    * If the originally loaded product had no discount,
    * the theme may not have created the banner at all.
    */
    if (!saleTag && hasDiscount) {
      saleTag = document.createElement("div");
      saleTag.className = "hc-sale-tag";

      const discountText = document.createElement("span");
      saleTag.appendChild(discountText);

      cardWrapper.insertBefore(saleTag, card);
    }

    // No banner exists and no discount applies, so nothing else is needed.
    if (!saleTag) return;

    if (!hasDiscount) {
      saleTag.hidden = true;
      saleTag.style.display = "none";
      return;
    }

    const discountPercentage = Math.floor(
      ((originalPrice - currentPrice) / originalPrice) * 100
    );

    let discountText = saleTag.querySelector("span");

    if (!discountText) {
      discountText = document.createElement("span");
      saleTag.replaceChildren(discountText);
    }

    discountText.textContent = `${discountPercentage}%`;

    saleTag.hidden = false;
    saleTag.removeAttribute("hidden");
    saleTag.style.removeProperty("display");
  }

  function updateCardPrice(card, price, compareAtPrice) {
    updateCardDiscountBanner(card, price, compareAtPrice);

    const priceWrapper = card.querySelector(".grid-product__price");

    if (
      !priceWrapper ||
      !price ||
      !window.theme ||
      !window.theme.Currency
    ) {
      return;
    }

    const pAmount = parseFloat(price);
    const cAmount = compareAtPrice
      ? parseFloat(compareAtPrice)
      : 0;

    const formattedPrice =
      window.theme.Currency.formatMoney(pAmount * 100);

    if (cAmount > pAmount) {
      const formattedCompare =
        window.theme.Currency.formatMoney(cAmount * 100);

      const saving = Math.floor(
        ((cAmount - pAmount) / cAmount) * 100
      );

      priceWrapper.innerHTML = `
        <span class="visually-hidden">Regular price</span>
        <span class="grid-product__price--original">
          ${formattedCompare}
        </span>
        <span class="visually-hidden">Sale price</span>
        ${formattedPrice}
        <span class="grid-product__price--savings">
          Save ${saving}%
        </span>
      `;
    } else {
      priceWrapper.innerHTML = `
        <span class="visually-hidden">Regular price</span>
        ${formattedPrice}
      `;
    }
  }

  function applyProductToCard(card, swatch) {
    const title = swatch.dataset.productTitle || "";
    const handle = swatch.dataset.handle || "";
    const url = swatch.dataset.url || "";
    const image = swatch.dataset.image || "";
    const imageAlt = swatch.dataset.imageAlt || "";
    const colour = swatch.dataset.colour || extractColourFromTitle(title) || "";
    const price = swatch.dataset.price || null;
    const compareAtPrice = swatch.dataset.compareAtPrice || null;

    updateCardTitles(card, title);
    updateCardLinks(card, url);
    updateCardImage(card, {
      title,
      url,
      image,
      imageAlt,
    });
    updateCardPrice(card, price, compareAtPrice);
    updateSelectedSwatch(card, handle, colour);

    card.dataset.creCurrentHandle = handle;
    card.dataset.creCurrentTitle = title;
  }

  function createSwatch(item) {
    const colour = item.colour;
    const product = item.product;
    const available = item.available;

    if (!colour) return null;

    const swatch = document.createElement("button");
    swatch.type = "button";
    swatch.className = "cre-t-7-collection-colour-swatches__swatch";
    swatch.dataset.colour = colour;

    const className = getColourClass(colour);

    if (className) {
    className.split(" ").forEach(function (singleClassName) {
        swatch.classList.add(singleClassName);
    });
    } else {
    swatch.style.backgroundColor = colour.toLowerCase();
    }

    const tooltip = document.createElement("span");
    tooltip.className = "cre-t-7-collection-colour-swatches__tooltip";
    tooltip.textContent = colour;
    swatch.appendChild(tooltip);

    if (!available || !product) {
      swatch.classList.add("is-unavailable");
      swatch.setAttribute("aria-disabled", "true");
      swatch.setAttribute("tabindex", "-1");
      swatch.setAttribute("title", `${colour} unavailable`);
      return swatch;
    }

    const url = buildProductUrl(product);

    swatch.dataset.handle = product.handle;
    swatch.dataset.url = url;
    swatch.dataset.productTitle = product.title || "";
    swatch.dataset.image = product.featuredImage?.url || "";
    swatch.dataset.imageAlt = product.featuredImage?.altText || product.title || "";

    if (product.price) swatch.dataset.price = product.price;
    if (product.compareAtPrice) swatch.dataset.compareAtPrice = product.compareAtPrice;

    swatch.setAttribute("title", colour);
    swatch.setAttribute("aria-label", colour);

    return swatch;
  }

  async function renderSwatchesForCard(card) {
    if (!card) return;
    if (!document.documentElement.contains(card)) return;
    if (card.dataset.creSwatchesReady === "true") return;
    if (card.dataset.creSwatchesLoading === "true") return;

    card.dataset.creSwatchesLoading = "true";

    try {
      const productId = card.dataset.productId;
      const currentTitle = getPrimaryTitle(card);
      const currentHandle = getCurrentHandle(card);

      if (!productId || !currentTitle) {
        ensureSwatchPlaceholder(card);
        return;
      }

      const groupTag = await getGroupTag(productId);

      if (!groupTag) {
        ensureSwatchPlaceholder(card);
        return;
      }

      const groupProducts = await getProductsByGroup(groupTag);

      if (!groupProducts.length) {
        ensureSwatchPlaceholder(card);
        return;
      }

      const allGroupColours = [];
      const seenColours = new Set();

      groupProducts.forEach(function (product) {
        const colour = extractColourFromTitle(product.title);

        if (!colour) return;

        const key = colour.toLowerCase();

        if (seenColours.has(key)) return;

        seenColours.add(key);
        allGroupColours.push(colour);
      });

      if (!allGroupColours.length) {
        ensureSwatchPlaceholder(card);
        return;
      }

      const colourOrder = getColourOrder();

      const swatchItems = allGroupColours
        .map(function (colour) {
          const product = findMatchingProductForColour(groupProducts, currentTitle, colour);

          return {
            colour,
            product,
            available: !!product && product.isAvailable,
          };
        })
        .sort(function (a, b) {
          const indexA = colourOrder.indexOf(a.colour);
          const indexB = colourOrder.indexOf(b.colour);
          const safeA = indexA === -1 ? 999 : indexA;
          const safeB = indexB === -1 ? 999 : indexB;

          if (safeA !== safeB) return safeA - safeB;

          return a.colour.localeCompare(b.colour);
        });

      if (swatchItems.length <= 1) {
        ensureSwatchPlaceholder(card);
        return;
      }

      const target = card.querySelector(INSERT_TARGET_SELECTOR) || card.querySelector(".boost-sd__product-info");

      if (!target) return;

      const existingBlock = target.querySelector(".cre-t-7-collection-colour-swatches");

      if (existingBlock) {
        existingBlock.remove();
      }

      removeSwatchPlaceholder(card);

      const currentColour = extractColourFromTitle(currentTitle);

      const wrapper = document.createElement("div");
      wrapper.className = "cre-t-7-collection-colour-swatches";

      const label = document.createElement("span");
      label.className = "cre-t-7-collection-colour-swatches__label";
      label.innerHTML = `Colour<span class="cre-t-7-collection-colour-swatches__label-current">${currentColour || ""}</span>`;

      const list = document.createElement("div");
      list.className = "cre-t-7-collection-colour-swatches__list";

      swatchItems.forEach(function (item) {
        const swatch = createSwatch(item);

        if (swatch) {
          list.appendChild(swatch);
        }
      });

      if (!list.children.length) {
        ensureSwatchPlaceholder(card);
        return;
      }

      wrapper.appendChild(label);
      wrapper.appendChild(list);
      target.prepend(wrapper);

      updateSelectedSwatch(card, currentHandle, currentColour);

      card.dataset.creCurrentHandle = currentHandle;
      card.dataset.creCurrentTitle = currentTitle;
      card.dataset.creSwatchesReady = "true";
      card.dataset.creSignature = getCardSignature(card);
    } catch (error) {
      ensureSwatchPlaceholder(card);
      console.error("Collection swatches error:", error);
    } finally {
      delete card.dataset.creSwatchesLoading;
    }
  }

    function eventHandler() {
    live(".cre-t-7-collection-colour-swatches__swatch:not(.is-unavailable)", "click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const card = this.closest(CARD_SELECTOR);
        if (!card) return;

        applyProductToCard(card, this);
    });

    live(".cre-t-7-collection-colour-swatches__swatch:not(.is-unavailable)", "mouseenter", function () {
        prefetchUrl(this.dataset.url || "");
    });
    }

  function isCardNearViewport(card) {
    const rect = card.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    return rect.top <= vh + 250 && rect.bottom >= -250;
  }

  function observeCard(card) {
    if (!card || !io) return;
    if (!document.documentElement.contains(card)) return;

    io.observe(card);
  }

  function scanCards(root) {
    if (!root) return;

    root.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      const newSignature = getCardSignature(card);
      const oldSignature = card.dataset.creSignature || "";

      if (oldSignature && oldSignature !== newSignature) {
        resetCard(card);
      }

      if (card.dataset.creSwatchesReady !== "true") {
        observeCard(card);

        if (isCardNearViewport(card)) {
          renderSwatchesForCard(card);
        }
      }
    });
  }

  function getGridRoot() {
    return document.querySelector(GRID_WRAPPER_SELECTOR) || document.body;
  }

  function attachGridObserver() {
    const nextGridRoot = getGridRoot();

    if (!nextGridRoot) return;
    if (currentGridRoot === nextGridRoot && mo) return;

    if (mo) {
      mo.disconnect();
    }

    currentGridRoot = nextGridRoot;

    scanCards(currentGridRoot);

    mo = new MutationObserver(
      debounce(function () {
        if (!document.documentElement.contains(currentGridRoot)) {
          attachGridObserver();
          return;
        }

        scanCards(currentGridRoot);
      }, 300)
    );

    mo.observe(currentGridRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["data-product-id", "href"],
    });
  }

  function initObservers() {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          renderSwatchesForCard(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "250px 0px",
        threshold: 0.01,
      }
    );

    attachGridObserver();

    const rootWatcher = new MutationObserver(
      debounce(function () {
        const latestGridRoot = getGridRoot();

        if (latestGridRoot !== currentGridRoot) {
          attachGridObserver();
        }
      }, 300)
    );

    rootWatcher.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  waitForElement(
    ".boost-sd__product-title",
    function () {
      if (!window.ukrCollectionColourSwatchesLoaded) {
        window.ukrCollectionColourSwatchesLoaded = true;
        initObservers();
        eventHandler();
      }
    },
    50,
    15000
  );
})();